var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 13.3334C6.03334 13.3334 4.83334 14.5334 4.83334 16.0001C4.83334 17.4667 6.03334 18.6667 7.50001 18.6667C8.96668 18.6667 10.1667 17.4667 10.1667 16.0001C10.1667 14.5334 8.96668 13.3334 7.50001 13.3334Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 13.3334C6.03334 13.3334 4.83334 14.5334 4.83334 16.0001C4.83334 17.4667 6.03334 18.6667 7.50001 18.6667C8.96668 18.6667 10.1667 17.4667 10.1667 16.0001C10.1667 14.5334 8.96668 13.3334 7.50001 13.3334Z",
    fill: "url(#paint0_linear_1625_9468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 13.3334C24.7 13.3334 23.5 14.5334 23.5 16.0001C23.5 17.4667 24.7 18.6667 26.1667 18.6667C27.6333 18.6667 28.8333 17.4667 28.8333 16.0001C28.8333 14.5334 27.6333 13.3334 26.1667 13.3334Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 13.3334C24.7 13.3334 23.5 14.5334 23.5 16.0001C23.5 17.4667 24.7 18.6667 26.1667 18.6667C27.6333 18.6667 28.8333 17.4667 28.8333 16.0001C28.8333 14.5334 27.6333 13.3334 26.1667 13.3334Z",
    fill: "url(#paint1_linear_1625_9468)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 13.3334C15.3667 13.3334 14.1667 14.5334 14.1667 16.0001C14.1667 17.4667 15.3667 18.6667 16.8333 18.6667C18.3 18.6667 19.5 17.4667 19.5 16.0001C19.5 14.5334 18.3 13.3334 16.8333 13.3334Z",
    fill: "#7D14FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 13.3334C15.3667 13.3334 14.1667 14.5334 14.1667 16.0001C14.1667 17.4667 15.3667 18.6667 16.8333 18.6667C18.3 18.6667 19.5 17.4667 19.5 16.0001C19.5 14.5334 18.3 13.3334 16.8333 13.3334Z",
    fill: "url(#paint2_linear_1625_9468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1625_9468",
    x1: 4.83334,
    y1: 13.3334,
    x2: 10.1667,
    y2: 18.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1625_9468",
    x1: 23.5,
    y1: 13.3334,
    x2: 28.8334,
    y2: 18.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1625_9468",
    x1: 14.1667,
    y1: 13.3334,
    x2: 19.5,
    y2: 18.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreBold);
export default __webpack_public_path__ + "static/media/moreBold.75f552f1e961e7f1a14ecc4e4da2400e.svg";
export { ForwardRef as ReactComponent };